export { getOrg, getUniverse, listOrgs, listPartnerApprovals, listUniverses, listUniversesByOrg, submitPartnerApproval } from './chunk-LV3HULGJ.js';
export { licenceStatus, universeStatusChip } from './chunk-RFIS2HKK.js';
import { getDoc, doc } from 'firebase/firestore';
import { COLLECTIONS } from '@storyworm/schema';

async function isSsupAdmin(db, email) {
  const snap = await getDoc(doc(db, COLLECTIONS.admins, email.toLowerCase()));
  return snap.exists();
}

export { isSsupAdmin };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map